export default __webpack_public_path__ + "static/media/resumepage.a5168c76.png";